// extracted by mini-css-extract-plugin
export var avatarContainer = "_gm-0";
export var avatarTypingWave = "_gm-i";
export var gray = "_gm-f";
export var green = "_gm-c";
export var icon = "_gm-9";
export var image = "_gm-1";
export var lg = "_gm-6";
export var md = "_gm-5";
export var presenceDot = "_gm-b";
export var red = "_gm-d";
export var sm = "_gm-4";
export var status = "_gm-a";
export var typingDot = "_gm-h";
export var typingPill = "_gm-g";
export var xl = "_gm-7";
export var xs = "_gm-3";
export var xxl = "_gm-8";
export var xxs = "_gm-2";
export var yellow = "_gm-e";